export default "__VITE_ASSET__CLgWe3OG__"